export default __webpack_public_path__ + "static/media/burger-cheese.96c4f3bc.svg";